var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticClass:"submit-btn",staticStyle:{"width":"100%"},attrs:{"type":"success"},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }